import { useTranslation } from 'react-i18next';
import {
  DeleteIconButton,
  EditIconButton,
  Icon,
  Page,
  SimpleIconButton,
} from '@/components';
import { Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetAnnouncementDetailsQuery } from '@/redux/announcements';
import {
  AnnouncementDetailsPanel,
  useDeleteAnnouncementAction,
  usePublishAnnouncementAction,
} from '@/views/Announcements.Details';
import { RocketOutlined } from '@ant-design/icons';

const useId = () => {
  const params = useParams<'id'>();
  return params.id!;
};

export function AnnouncementDetailsPage() {
  const { t } = useTranslation();
  const id = useId();
  const { data } = useGetAnnouncementDetailsQuery({ id });
  const title = data?.title ?? t('fetchFallbackTitle');
  const push = useNavigate();
  const isPublished = data?.status === 'Published';

  const { deleteAction } = useDeleteAnnouncementAction({
    onSuccess: () => push(-1),
  });

  const { publishAction } = usePublishAnnouncementAction();

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#announcements">
          {t('announcements.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="announcement" />}
          color="#814A93"
          actions={
            <Space>
              {!isPublished && (
                <EditIconButton
                  onClick={() => push(`/admin/announcements/${id}/edit`)}
                />
              )}
              <DeleteIconButton onClick={() => deleteAction(id)} />
              {!isPublished && (
                <SimpleIconButton
                  iconButton={<RocketOutlined />}
                  action={t('announcements.action.publish')}
                  onClick={() => {
                    publishAction(id);
                  }}
                />
              )}
            </Space>
          }
        >
          <AnnouncementDetailsPanel id={id} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
